import { explainWhatsAppProviderFailure, manualWhatsAppSupportWindow } from '../../lib/manualMessaging';

export { manualWhatsAppSupportWindow };

export function isRecruitmentThread(thread) {
  return String(thread?.department || thread?.inbox_department || '').trim().toLowerCase() === 'recruitment';
}

export function recruitmentWhatsAppFailure(message = {}) {
  return explainWhatsAppProviderFailure(message);
}

export function hasRecentPendingWhatsAppDelivery(messages = [], nowMs = Date.now(), maxAgeMs = 60000) {
  return (Array.isArray(messages) ? messages : []).some((message) => {
    if (String(message?.channel || '').toLowerCase() !== 'whatsapp') return false;
    if (String(message?.direction || '').toLowerCase() !== 'outbound') return false;
    if (String(message?.delivery_status || '').toLowerCase() !== 'provider_accepted') return false;
    const createdMs = new Date(message?.created_at || '').getTime();
    return Number.isFinite(createdMs) && nowMs >= createdMs && (nowMs - createdMs) <= maxAgeMs;
  });
}

export function recruitmentInboxPollInterval(messages = [], nowMs = Date.now()) {
  return hasRecentPendingWhatsAppDelivery(messages, nowMs) ? 2000 : 5000;
}

export function recruitmentMessageState(message = {}) {
  const direction = String(message.direction || '').toLowerCase();
  const channel = String(message.channel || 'email').toLowerCase();
  const delivery = String(message.delivery_status || '').toLowerCase();

  if (direction === 'inbound') {
    return { label: 'Received', tone: 'blue' };
  }

  if (channel === 'whatsapp') {
    if (delivery === 'read') return { label: 'Read', tone: 'blue' };
    if (delivery === 'delivered') return { label: 'Delivered', tone: 'green' };
    if (delivery === 'failed') return { label: 'Failed', tone: 'red' };
    if (delivery === 'sent') return { label: 'Sent', tone: 'green' };
    if (delivery === 'provider_accepted' || message.provider_message_id) {
      return { label: 'Accepted', tone: 'slate' };
    }
  }

  if (message.provider_message_id) return { label: 'Sent', tone: 'green' };
  return { label: 'Recorded', tone: 'slate' };
}

export function approvedWhatsAppTemplates(status, templates) {
  if (!status?.ready || !Array.isArray(templates)) return [];
  const allowed = new Set(status?.templates?.configured_template_keys || []);
  return templates.filter((template) => allowed.has(template?.key));
}

export function renderRecruitmentTemplate(template, applicant) {
  const firstName = String(applicant?.first_name || applicant?.preferred_name || 'there').trim() || 'there';
  const fullName = [applicant?.first_name, applicant?.last_name].filter(Boolean).join(' ').trim() || firstName;
  const replace = (value) => String(value || '')
    .replaceAll('{first_name}', firstName)
    .replaceAll('{full_name}', fullName);

  return {
    subject: replace(template?.subject),
    body: replace(template?.body),
  };
}

export function isActivatedStaff(applicant) {
  const status = String(applicant?.status || '').trim().toLowerCase();
  return ['onboarding', 'active', 'inactive', 'active_employee'].includes(status);
}
